export default {
    handleErrosDose(errorData, errorForm) {
        let error = errorData.errors;

        errorForm.descricao = error.descricao ? error.descricao[0] : '';
        errorForm.br_dose = error.br_dose ? error.br_dose[0] : '';
        errorForm.ativo = error.ativo ? error.ativo[0] : '';
        errorForm.error = '';

        if(typeof error == 'string') {
            errorForm.error = error;
        }
    }
}